import { render, staticRenderFns } from "./adjustment-table.vue?vue&type=template&id=d22807a6&scoped=true"
import script from "./adjustment-table.vue?vue&type=script&lang=js"
export * from "./adjustment-table.vue?vue&type=script&lang=js"
import style0 from "./adjustment-table.vue?vue&type=style&index=0&id=d22807a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22807a6",
  null
  
)

export default component.exports